export const REFERRERS = {
  FAVORITE: 'favorite',
  MAX_SEARCHES: 'max_searches',
  MESSAGE_EXISTING_USER: 'message_existing_user',
  POST_LEAD_SIGN_UP: 'message',
  SEARCH: 'search',
  SEARCH_EXISTING_USER: 'search_existing_user',
  FOR_YOU: 'for_you',
} as const
